import { useMutation } from "@apollo/client";

import {
  CURRENT_USER_QUERY,
  ACTIVE_INACTIVE_OWN_OEM_ADDITIONAL_FIELD,
  CREATE_OWN_OEM_CUSTOM_ADDITION_FIELD,
  DELETE_OWN_OEM_CUSTOM_ADDITIONAL_FIELD,
  LIST_OWN_OEM_CUSTOM_ADDITIONAL_FIELDS_QUERY,
  UPDATE_OWN_OEM_CUSTOM_ADDITION_FIELD,
  UPDATE_OWN_OEM_CUSTOM_FIELDS_ORDER,
} from "~/api";

export const useActiveInactiveOwnOemAdditionalField = (type) => {
  const [toggle, { error, loading }] = useMutation(
    ACTIVE_INACTIVE_OWN_OEM_ADDITIONAL_FIELD,
    {
      refetchQueries: [
        {
          query: LIST_OWN_OEM_CUSTOM_ADDITIONAL_FIELDS_QUERY,
          variables: { type },
        },
        { query: CURRENT_USER_QUERY },
      ],
    },
  );

  return {
    loading,
    error,
    activeInactiveOwnOemAdditionalField: async (id, enabled) =>
      toggle({
        variables: {
          id,
          enabled,
        },
      }),
  };
};

export const useCreateOwnOemCustomField = (type) => {
  const [create, { loading, error }] = useMutation(
    CREATE_OWN_OEM_CUSTOM_ADDITION_FIELD,
    {
      refetchQueries: [
        {
          query: LIST_OWN_OEM_CUSTOM_ADDITIONAL_FIELDS_QUERY,
          variables: { type },
        },
        { query: CURRENT_USER_QUERY },
      ],
    },
  );

  return {
    loading,
    error,
    createOwnOemCustomField: async (input) => {
      return create({
        variables: {
          input,
        },
      });
    },
  };
};

export const useUpdateOwnOemCustomField = () => {
  const [update, { loading, error }] = useMutation(
    UPDATE_OWN_OEM_CUSTOM_ADDITION_FIELD,
    {
      refetchQueries: [{ query: CURRENT_USER_QUERY }],
    },
  );

  return {
    loading,
    error,
    updateOwnOemCustomField: async (input) =>
      update({
        variables: {
          input,
        },
      }),
  };
};

export const useDeleteOwnOemCustomAdditionalField = () => {
  const [remove, { loading, error }] = useMutation(
    DELETE_OWN_OEM_CUSTOM_ADDITIONAL_FIELD,
    {
      refetchQueries: [{ query: CURRENT_USER_QUERY }],
    },
  );

  return {
    loading,
    error,
    deleteOwnOemCustomAdditionalField: async (input) =>
      remove({
        variables: {
          input,
        },
        update(cache) {
          cache.evict({
            id: "ROOT_QUERY",
            fieldName: "listOwnOemKanbanAssets",
          });

          const { currentUser } =
            cache.readQuery({
              query: CURRENT_USER_QUERY,
            }) || {};

          if (currentUser) {
            const boards = currentUser.boards || [];

            cache.writeQuery({
              query: CURRENT_USER_QUERY,
              data: {
                currentUser: {
                  ...currentUser,
                  boards: boards.map((board) => {
                    return {
                      ...board,
                      customFields: board.customFields.filter(
                        (customField) => customField._id !== input._id,
                      ),
                    };
                  }),
                },
              },
            });
          }

          cache.gc();
        },
      }),
  };
};

export const useUpdateOwnOemCustomFieldsOrder = () => {
  const [update, { loading, error }] = useMutation(
    UPDATE_OWN_OEM_CUSTOM_FIELDS_ORDER,
  );

  return {
    loading,
    error,
    updateOwnOemCustomFieldsOrder: async (input) =>
      update({
        variables: {
          input,
        },
      }),
  };
};
